// startup
// Load entry module and return exports
__webpack_modules__["./src/components/menu/menu.js"]();
__webpack_modules__["./src/components/menu/_menu.scss"]();
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["?6190"]();
